export { T, D, D2, N, N0, N4, I2, I3, I4, TS1, TS2 } from "./global/globals"

export const TextEnsureNewLine = (val: string) => {
  if (!val) {
    return val
  }
  return val.replace(/\r\n/g, "\n").replace(/\r/g, "\n")
}

export const TextRemoveNewLines = (val: string) => {
  if (!val) {
    return val
  }
  return val.replace(/[\r\n]+/g, "")
}

export const TextHtmlLines = (parts: (string | undefined | null)[]) => {
  if (!parts) {
    return ""
  }
  return parts
    .filter(Boolean)
    .map((p) => (p.indexOf("<br") > -1 ? p.replace(/[\r\n]+/g, "") : p))
    .join("<br>")
}

export const TextLines = (parts: (string | undefined | null)[]) => {
  if (!parts) {
    return ""
  }
  return parts.filter(Boolean).join("\n")
}
